// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { WhiteBlock } from 'components/WhiteBlock';
import { Title } from 'components/Title';
import { ListSelect } from 'components/ListSelect';
import { fieldsArrF, fieldsArrIP, fieldsArrJur } from 'constants/stringConstants';
import { DocumentInfo } from 'components/BlocksContent/DocumentInfo';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import classNames from 'classnames';
import { useCreateBeneficiarMutation } from 'redux/Api/beneficiariesApi/beneficiariesApi';
import { setInfoProfileCreate, setResetField } from 'redux/createProfile/slice';
import { AddressDadataReg } from 'components/AddressDadataReg';
import { useNavigate } from 'react-router-dom';
import { getDateFormatForBack } from 'utils/date';
import { DateInput } from '@mantine/dates';
import moment from 'moment';
import { ReactComponent as CalendarSvg } from 'assets/img/filter/iconCalendarBig.svg';
import { ReactComponent as AccSvg } from './img/iconAccountCard.svg';
import styles from './BeneficiarCreate.module.scss';
import { searchSuggestingApi, searchSuggestingCompany } from 'api/getApi';
import PhoneForm from 'components/PhoneForm';
import { applySmartDateKey, formatDateInput } from 'utils/dateinput';

export const BeneficiarCreate = () => {
  const [suggestingValueArr, setSuggestingValueArr] = useState<any[]>([]);
  const [suggestingFmsUnitArr, setSuggestingFmsUnitArr] = useState<any[]>([]);
  const navigate = useNavigate();
  const {
    control,
    register,
    formState: { errors, isValid },
    handleSubmit,
    reset,
    setValue,
    watch,
    getValues,
  } = useForm({
    mode: 'onBlur',
    defaultValues: {
      jur_address: '',
      registration_address: '',
      citizenship: 'Россия',
      document: 'Паспорт',
    },
  });

  //Константы для вытягивания из формы определённых значений
  const innValue = watch('inn');
  const issuerCodeValue = watch('issuer_code');

  const dispatch = useDispatch();

  const [createBeneficiar, { error, isSuccess }] = useCreateBeneficiarMutation();

  useEffect(() => {
    if (error?.data) {
      alert(error?.data?.message);
    }
  }, [error]);

  useEffect(() => {
    if (isSuccess) {
      navigate('/beneficiaries');
      dispatch(setResetField());
      reset();
    }
  }, [isSuccess]);

  const {
    doc_code,
    nationality,
    series,
    number,
    dep_code,
    doc_place,
    doc_date,
    birth_place,
    reg_address,
    jur_address,
    errorStatusField,
  } = useSelector((state: RootState) => state.createProfile);
  const lists = [
    { name: 'Юридическое лицо', key: 'J' },
    { name: 'ИП', key: 'I' },
    { name: 'Физическое лицо', key: 'F' },
  ];

  const [activeList, setActiveList] = useState(lists[0]);

  const handlerResetField = () => {
    dispatch(setResetField());
    reset();
  };

  const onSubmit = (data: any) => {
    if (data.phone && !data.phone.startsWith('7')) {
      data.phone = `7${data.phone}`;
    }
    if (activeList.key === 'J') {
      const {
        inn,
        kpp,
        phone,
        email,
        ogrn,
        jur_name,
        commission_min_amount,
        commission_percent,
        ...userObj
      } = data;

      const body = {
        is_fake: false,
        customer: {
          legal_type: activeList.key,
          jur_address,
          phone,
          email,
          inn,
          jur_name,
          ogrn,
          kpp,
          commission_min_amount,
          commission_percent,
        },
        user: {
          ...userObj,
          phone,
          email,
        },
      };
      createBeneficiar({ body });
    } else if (activeList.key === 'I') {
      const {
        password,
        kpp,
        inn,
        ogrn,
        commission_min_amount,
        commission_percent,
        jur_address: jur_addressFromForm,
        is_resident,
        series,
        number,
        issuer_name,
        issuer_code,
        issue_date,
        birth_date,
        registration_address,
        birth_place,
        ...obj
      } = data;

      const cleanObj = { ...(obj || {}) };
      delete cleanObj.passport;

      const body = {
        customer: {
          ...cleanObj,
          legal_type: activeList.key,
          ogrn,
          kpp,
          inn,
          jur_address: jur_addressFromForm || registration_address || jur_address,
          commission_min_amount,
          commission_percent,
        },
        user: { ...cleanObj, password },
        passport: {
          name: cleanObj.name,
          surname: cleanObj.surname,
          patronymic: cleanObj.patronymic,
          series,
          number,
          issuer_name,
          issuer_code: String(issuer_code ?? '').replace(/-/g, ''),
          issue_date: issue_date ? moment(issue_date).format('YYYY-MM-DD') : '',
          birth_date: birth_date ? moment(birth_date).format('YYYY-MM-DD') : '',
          registration_address,
          birth_place,
          citizenship: 'RU',
          is_resident: typeof is_resident === 'boolean' ? !is_resident : true,
        },
      };

      createBeneficiar({ body });
    } else {
      const { dob, is_resident, inn, password, ...obj } = data;
      const body = {
        customer: {
          legal_type: activeList.key,
          birth_place,
          reg_address,
          dob: getDateFormatForBack(dob),
          is_resident: typeof is_resident === 'boolean' ? !is_resident : true,
          inn,
          ...obj,
        },
        user: {
          password,
          ...obj,
        },
        doc: {
          doc_code,
          nationality,
          series,
          number,
          dep_code: dep_code ? dep_code?.slice(0, 3) + '-' + dep_code?.slice(3) : '',
          doc_place,
          doc_date: getDateFormatForBack(doc_date),
        },
      };

      createBeneficiar({ body });
    }
  };

  useEffect(() => {
    reset({
      jur_address: '',
      reg_address: '',
      inn: '',
      ogrn: '',
      jur_name: '',
      kpp: '',
      ...(activeList.key === 'I'
        ? {
            citizenship: 'Россия',
            document: 'Паспорт',
          }
        : {}),
    });
    dispatch(setResetField());
  }, [activeList, reset, dispatch]);

  const checkErrorObj = useMemo(() => {
    const { jur_address, ...errorObj } = errorStatusField || {};
    for (const key in errorObj) {
      if (errorObj[key] === 1) {
        return errorObj[key];
      }
    }

    const docObj = {
      series,
      number,
      dep_code,
      doc_place,
      doc_date,
      birth_place,
      reg_address,
    };

    for (const key in docObj) {
      if (docObj[key] === '') {
        return 1;
      }
    }
  }, [series, number, dep_code, doc_place, doc_date, birth_place, reg_address]);

  const disabledJForm = !isValid || !jur_address.length;
  const disabledFForm = !isValid || !!checkErrorObj;
  const disabledIForm = !isValid || !jur_address.length;

  const refPhone = useRef();
  const skipIssuerCodeSuggestEffect = useRef(false);

  const setSuggestingValue = async () => {
    const res = await searchSuggestingCompany(innValue);
    setSuggestingValueArr(res);
  };

  const setSuggestingFmsUnitValue = async () => {
    const res = await searchSuggestingApi(issuerCodeValue);
    setSuggestingFmsUnitArr(res);
  };

  const issuerCodeInputProps = (rules, blurDelay) => {
    const r = register('issuer_code', rules);
    return {
      ...r,
      onChange: (e) => {
        const v = e.target.value.replace(/[^\d-]/g, '');
        if (v !== e.target.value) e.target.value = v;
        r.onChange(e);
      },
      onFocus: () => {
        if (String(getValues('issuer_code') ?? '').length < 7) {
          void setSuggestingFmsUnitValue();
        }
      },
      onBlur: (e) => {
        r.onBlur(e);
        setTimeout(() => setSuggestingFmsUnitArr([]), blurDelay ? 150 : 0);
      },
    };
  };

  //Функция для запроса данных для dadata
  useEffect(() => {
    if (innValue) {
      setSuggestingValue();
    }
  }, [innValue]);

  useEffect(() => {
    if (activeList.key !== 'I') {
      skipIssuerCodeSuggestEffect.current = false;
      setSuggestingFmsUnitArr([]);
      return;
    }
    if (skipIssuerCodeSuggestEffect.current) {
      skipIssuerCodeSuggestEffect.current = false;
      return;
    }
    if (issuerCodeValue) {
      setSuggestingFmsUnitValue();
    } else {
      setSuggestingFmsUnitArr([]);
    }
  }, [issuerCodeValue, activeList.key]);

  useEffect(() => {
    if (!suggestingFmsUnitArr.length) return;
    const onMouseDown = (e) => {
      const t = e.target;
      const el = t instanceof Element ? t : t?.parentElement;
      if (el instanceof Element && el.closest('[data-fms-issuer-root]')) return;
      setSuggestingFmsUnitArr([]);
    };
    document.addEventListener('mousedown', onMouseDown);
    return () => document.removeEventListener('mousedown', onMouseDown);
  }, [suggestingFmsUnitArr.length]);

  // функция для атоматического подставления данных в форму при выборе организации из списка Dadata
  const handleSelectItem = (elem) => {
    setValue('kpp', elem?.data?.kpp);
    setValue('ogrn', elem?.data?.ogrn);
    setValue('jur_name', elem?.value);
    setValue('jur_address', elem?.data?.address?.value);
    setValue('registration_address', elem?.data?.address?.value);
    dispatch(
      setInfoProfileCreate({ key: 'jur_address', value: elem?.data?.address?.value }),
    );
    setSuggestingValueArr([]);
  };

  const handleSelectFmsUnit = (elem) => {
    setValue('issuer_name', elem?.value || '');
    const c = String(elem?.data?.code ?? '').replace(/\D/g, '');
    setValue('issuer_code', c.length >= 6 ? c.slice(0, 3) + '-' + c.slice(3) : c);
    skipIssuerCodeSuggestEffect.current = true;
    setSuggestingFmsUnitArr([]);
  };

  useEffect(() => {
    return () => {
      // Полная очистка всех полей в Redux
      const fieldsToClear = [
        'jur_address',
        'reg_address',
        'doc_code',
        'nationality',
        'series',
        'number',
        'dep_code',
        'doc_place',
        'doc_date',
        'birth_place',
      ];
      fieldsToClear.forEach((field) => {
        dispatch(setInfoProfileCreate({ key: field, value: '' }));
      });

      // Или если есть другие экшены для очистки
      dispatch(setResetField());
    };
  }, [dispatch]);

  const lastStartDateInputValueRef = useRef<string>('');

  const handleSmartDateKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const input = event.currentTarget;
    const { selectionStart, selectionEnd, value } = input;
    const keyResult = applySmartDateKey({
      key: event.key,
      value,
      selectionStart,
      selectionEnd,
    });
    if (!keyResult.handled) return;

    event.preventDefault();

    input.value = keyResult.value;
    lastStartDateInputValueRef.current = keyResult.value;
    input.setSelectionRange(
      Math.min(keyResult.caretPos, keyResult.value.length),
      Math.min(keyResult.caretPos, keyResult.value.length),
    );
  };

  return (
    <WhiteBlock className={styles.root}>
      <div onClick={() => setValue('inn', '12312323')} className={styles.root_title}>
        <AccSvg />
        <Title title='Карточка компании' />
      </div>
      <ListSelect
        handlerResetField={handlerResetField}
        placeholder='Тип'
        list={lists}
        setActiveItem={setActiveList}
        activeItem={activeList.name}
      />
      <form
        autoComplete='off'
        style={activeList.key === 'F' ? { rowGap: 20 } : {}}
        onSubmit={handleSubmit(onSubmit)}>
        {(activeList.key === 'J'
          ? fieldsArrJur
          : activeList.key === 'I'
          ? fieldsArrIP
          : fieldsArrF
        ).map((elem, i) =>
          elem.items ? (
            <div key={i} style={{ display: 'flex', columnGap: 12 }}>
              {elem.items.map((item, ind) => (
                <div
                  key={ind}
                  className={styles.rootInput}
                  {...(item.name === 'issuer_code'
                    ? { 'data-fms-issuer-root': '' }
                    : {})}>
                  {item.name === 'issuer_code' ? (
                    <>
                      <input
                        autoComplete={
                          item.type === 'text' ? 'no-autofill-please' : 'new-password'
                        }
                        style={item.style || undefined}
                        placeholder={item.placeholder}
                        className={classNames(
                          styles.input,
                          errors[item.name] && styles.input_error,
                        )}
                        type={item.type}
                        {...issuerCodeInputProps(
                          {
                            required: item.required,
                            minLength: {
                              value: item.minLength,
                              message: item.minLengthMessage,
                            },
                            maxLength: {
                              value: item.maxLength,
                              message: item.maxLengthMessage,
                            },
                          },
                          false,
                        )}
                      />
                      <span
                        className={classNames(
                          styles.rootInput_placeholder,
                          errors[item.name] && styles.rootInput_placeholder_error,
                        )}>
                        {item.placeholder}
                      </span>
                      {!!suggestingFmsUnitArr.length && (
                        <ul
                          className={styles.list}
                          style={{
                            top: 'calc(100% + 6px)',
                            left: 0,
                            right: 'auto',
                            width: 360,
                            zIndex: 10,
                          }}>
                          {suggestingFmsUnitArr?.map((sugItem: any, index: number) => (
                            <li
                              className={styles.item}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                handleSelectFmsUnit(sugItem);
                              }}
                              key={index}>
                              {sugItem?.data?.code} {sugItem?.value}
                            </li>
                          ))}
                        </ul>
                      )}
                      {errors[item.name] && (
                        <p className={styles.errors}>
                          {errors[item.name]?.message || 'Error'}
                        </p>
                      )}
                    </>
                  ) : item.name === 'issue_date' || item.name === 'birth_date' ? (
                    <Controller
                      control={control}
                      name={item.name}
                      rules={{ required: item.required }}
                      render={({ field }) => (
                        <DateInput
                          value={field.value ?? null}
                          onChange={(value) => field.onChange(value)}
                          placeholder={moment(new Date()).format('DD.MM.YYYY')}
                          onInput={(event) => {
                            const formatted = formatDateInput(event.currentTarget.value);
                            if (event.currentTarget.value !== formatted) {
                              event.currentTarget.value = formatted;
                            }
                            lastStartDateInputValueRef.current = formatted;
                          }}
                          onKeyDown={handleSmartDateKeyDown}
                          dateParser={(value) => {
                            if (!value) return null;
                            const parsed = moment(value, 'DD.MM.YYYY', true);
                            return parsed.isValid() ? parsed.toDate() : null;
                          }}
                          rightSection={
                            <CalendarSvg style={{ height: '16px', width: '16px' }} />
                          }
                          rightSectionPointerEvents='none'
                          styles={{
                            input: {
                              height: '48px',
                              fontSize: '16px',
                              border: errors[item.name]
                                ? '1px solid red'
                                : '1px solid #EAF0FD',
                              borderRadius: '4px',
                              color: '#121922',
                              padding: '0 16px',
                            },
                            section: {
                              marginRight: '6px',
                            },
                          }}
                          highlightToday
                          valueFormat={'DD.MM.YYYY'}
                          clearable
                          allowDeselect
                          popoverProps={{ zIndex: 100001 }}
                        />
                      )}
                    />
                  ) : (
                    <input
                      autoComplete={item.placeholder || false}
                      step='any'
                      style={item.style || undefined}
                      placeholder={item.placeholder}
                      className={classNames(
                        styles.input,
                        errors[item.name] && styles.input_error,
                      )}
                      type={item.type}
                      {...register(`${item.name}`, {
                        required: item.required,
                        minLength: {
                          value: item.minLength,
                          message: item.minLengthMessage,
                        },
                        maxLength: {
                          value: item.minLength,
                          message: item.maxLengthMessage,
                        },
                      })}
                      // maxLength={+item.minLength}
                      maxLength={item.minLength ? Number(item.minLength) : undefined}
                    />
                  )}
                  {item.name !== 'issuer_code' && (
                    <>
                      <span
                        className={classNames(
                          styles.rootInput_placeholder,
                          errors[item.name] && styles.rootInput_placeholder_error,
                        )}>
                        {item.placeholder}
                      </span>
                      {errors[item.name] && (
                        <p className={styles.errors}>
                          {errors[item.name]?.message || 'Error'}
                        </p>
                      )}
                    </>
                  )}
                </div>
              ))}
            </div>
          ) : elem.name === 'phone' ? (
            <div key={i} style={{ position: 'relative' }}>
              <PhoneForm
                control={control}
                name={elem.name}
                rules={{
                  required: elem.required,
                  minLength: elem.minLength
                    ? {
                        value: elem.minLength,
                        message: elem.minLengthMessage,
                      }
                    : undefined,
                }}
                error={
                  errors[elem.name]
                    ? String(errors[elem.name]?.message || 'Error')
                    : undefined
                }
                inputClassName={styles.input}
                inputStyle={{
                  ...(elem.width ? { width: '378px' } : {}),
                }}
                inputRef={refPhone}
                placeholder='+7 (___) ___-__-__'
              />
              <span
                className={classNames(
                  styles.rootInput_placeholder,
                  errors[elem.name] && styles.rootInput_placeholder_error,
                )}>
                {elem.placeholder}
              </span>
              {errors[elem.name] && (
                <p className={styles.errors}>{errors[elem.name]?.message || 'Error'}</p>
              )}
            </div>
          ) : elem.name === 'issuer_code' ? (
            <div
              key={i}
              data-fms-issuer-root=''
              style={{ position: 'relative' }}
              className={styles.rootInput}>
              <input
                autoComplete={
                  elem.type === 'text' ? 'no-autofill-please' : 'new-password'
                }
                style={elem.width ? { width: '378px' } : {}}
                placeholder={elem.placeholder}
                className={classNames(
                  styles.input,
                  errors[elem.name] && styles.input_error,
                )}
                type={elem.type}
                {...issuerCodeInputProps(
                  {
                    required: elem.required,
                    minLength: {
                      value: elem.minLength,
                      message: elem.minLengthMessage,
                    },
                    maxLength: {
                      value: elem.maxLength,
                      message: elem.maxLengthMessage,
                    },
                  },
                  true,
                )}
              />
              <span
                className={classNames(
                  styles.rootInput_placeholder,
                  errors[elem.name] && styles.rootInput_placeholder_error,
                )}>
                {elem.placeholder}
              </span>
              {!!suggestingFmsUnitArr.length && (
                <ul
                  className={styles.list}
                  style={{
                    top: 'calc(100% + 6px)',
                    left: 0,
                    right: 'auto',
                    width: 360,
                    zIndex: 10,
                  }}>
                  {suggestingFmsUnitArr?.map((item: any, index: number) => (
                    <li
                      className={styles.item}
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => {
                        handleSelectFmsUnit(item);
                      }}
                      key={index}>
                      {item?.data?.code} {item?.value}
                    </li>
                  ))}
                </ul>
              )}
              {errors[elem.name] && (
                <p className={styles.errors}>{errors[elem.name]?.message || 'Error'}</p>
              )}
            </div>
          ) : elem.name === 'issue_date' || elem.name === 'birth_date' ? (
            <div key={i} className={styles.rootInput}>
              <Controller
                control={control}
                name={elem.name}
                rules={{ required: elem.required }}
                render={({ field }) => (
                  <DateInput
                    value={field.value ?? null}
                    onChange={(value) => field.onChange(value)}
                    placeholder={moment(new Date()).format('DD.MM.YYYY')}
                    rightSection={
                      <CalendarSvg style={{ height: '16px', width: '16px' }} />
                    }
                    rightSectionPointerEvents='none'
                    styles={{
                      input: {
                        height: '48px',
                        fontSize: '16px',
                        border: errors[elem.name] ? '1px solid red' : '1px solid #EAF0FD',
                        borderRadius: '4px',
                        color: '#121922',
                        padding: '0 16px',
                      },
                      section: {
                        marginRight: '6px',
                      },
                    }}
                    highlightToday
                    valueFormat={'DD.MM.YYYY'}
                    clearable
                    allowDeselect
                    popoverProps={{ zIndex: 100001 }}
                  />
                )}
              />
              <span
                className={classNames(
                  styles.rootInput_placeholder,
                  errors[elem.name] && styles.rootInput_placeholder_error,
                )}>
                {elem.placeholder}
              </span>
              {errors[elem.name] && (
                <p className={styles.errors}>{errors[elem.name]?.message || 'Error'}</p>
              )}
            </div>
          ) : elem.name === 'registration_address' ? (
            <div key={i} className={styles.rootInput} style={{ width: '100%' }}>
              <Controller
                control={control}
                name='registration_address'
                rules={{ required: elem.required }}
                render={({ field }) => (
                  <AddressDadataReg
                    placeholder='Адрес регистрации'
                    objKey='registration_address'
                    error={!!errors[elem.name]}
                    value={
                      field.value
                        ? ({ value: field.value } as DaDataSuggestion<DaDataAddress>)
                        : undefined
                    }
                    onChange={(suggestion) => {
                      const val = suggestion?.value || '';
                      field.onChange(val);
                      setValue('jur_address', val);
                    }}
                  />
                )}
              />
              <span
                className={classNames(
                  styles.rootInput_placeholder,
                  errors[elem.name] && styles.rootInput_placeholder_error,
                )}>
                Адрес регистрации
              </span>
              {errors[elem.name] && (
                <p className={styles.errors}>{errors[elem.name]?.message || 'Error'}</p>
              )}
            </div>
          ) : (
            <div key={i} className={styles.rootInput}>
              <input
                autoComplete={
                  elem.type === 'text' ? 'no-autofill-please' : 'new-password'
                }
                style={
                  elem.width
                    ? { width: '378px' }
                    : elem.name === 'dob'
                    ? { width: '200px' }
                    : {}
                }
                placeholder={elem.placeholder}
                className={classNames(
                  styles.input,
                  errors[elem.name] && styles.input_error,
                )}
                type={elem.type}
                {...register(`${elem.name}`, {
                  required: elem.required,
                  minLength: {
                    value: elem.minLength,
                    message: elem.minLengthMessage,
                  },
                  maxLength: {
                    value: elem.maxLength,
                    message: elem.maxLengthMessage,
                  },
                  pattern: elem.pattern
                    ? { value: elem.pattern, message: elem.patternMessage }
                    : '',
                })}
              />
              <span
                className={classNames(
                  styles.rootInput_placeholder,
                  errors[elem.name] && styles.rootInput_placeholder_error,
                )}>
                {elem.placeholder}
              </span>
              {errors[elem.name] && (
                <p className={styles.errors}>{errors[elem.name]?.message || 'Error'}</p>
              )}
            </div>
          ),
        )}

        {(activeList.key === 'F' || activeList.key === 'I') && (
          <>
            <div className={styles.wrapper}>
              <div className={classNames(styles.switch_box, styles.box_1)}>
                <input
                  type='checkbox'
                  className={styles.switch_1}
                  {...register('is_resident')}
                />
              </div>
              <p>Не является налоговым резидентом РФ</p>
            </div>

            {activeList.key === 'F' && (
              <>
                <Title title='Документ' />
                <DocumentInfo />
              </>
            )}
          </>
        )}
        <input
          type='submit'
          disabled={
            activeList.key === 'J'
              ? disabledJForm
              : activeList.key === 'F'
              ? disabledFForm
              : disabledIForm
          }
        />
      </form>
      {suggestingValueArr.length ? (
        <ul className={styles.list}>
          {suggestingValueArr?.map((elem: any, index: number) => (
            <li
              className={`${styles.item}
                     ${0 === index ? styles.item_active : ''}
                    `}
              onClick={() => {
                handleSelectItem(elem);
              }}
              key={index}>
              {elem.value}
            </li>
          ))}
        </ul>
      ) : null}
    </WhiteBlock>
  );
};
